angular.module('bribac.views.listSchedules', [
  'bribac.translations',
  'bribac.entities.kinds',
  'bribac.entities.scheduleFactory',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.components.whenLoaded',
  'bribac.components.scheduleDetails'
])

  .config(function(
    $routeProvider
  ) {
    var config = {
      templateUrl: 'list-schedules-view.html',
      controller: 'ListSchedulesViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: /*@ngInject*/ function(routeAuth) {return routeAuth.requireAuth()}}
    }

    $routeProvider.when('/schedule', config)
    $routeProvider.when('/templates/schedule', config)
  })

  .controller('ListSchedulesViewCtrl', function(
    $scope,
    $location,
    KINDS,
    scheduleFactory,
    api,
    permissions
  ) {
    var $ctrl = this
    $ctrl.permissions = permissions
    $ctrl.organization = {}

    $ctrl.pathPrefix = $location.path()

    $ctrl.schedulesPromise = api.get(KINDS.SCHEDULE).then(function(request) {
      $ctrl.schedules = request.data.list
      $ctrl.allSchedules = request.data.list
      if ($ctrl.permissions.canManageOrganizations()) {
        $scope.$watch('$ctrl.organization', filterSchedules)
      }
    })

    function filterSchedules() {
      if ($ctrl.organization.id != -1) {
        var filtered = $ctrl.allSchedules.filter(function(item) {
          return item.organization.id === $ctrl.organization.id
        })
        $ctrl.schedules = filtered
      } else {
        $ctrl.schedules = $ctrl.allSchedules
      }
    }
  })
